import { useState } from "react";
import { FileText, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import AdminSisterApps from "@/components/AdminSisterApps";

const BASE = process.env.REACT_APP_BACKEND_URL;

// The AI Coach blueprint for sister apps, at the top of Admin.
function EmailBlueprint() {
  const [to, setTo] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!/^\S+@\S+\.\S+$/.test(to.trim())) { toast("Add the team's email address."); return; }
    setBusy(true);
    try { await api.post("/admin/coach-blueprint/email", { to: to.trim(), note }); toast.success(`Blueprint sent to ${to.trim()}`); setTo(""); setNote(""); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't send. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-5 pt-5 border-t border-primary/20 space-y-2" data-testid="admin-blueprint-email">
      <p className="text-sm">Email it to a sister app's team</p>
      <Input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="team@sisterapp.com" className="rounded-full max-w-sm" data-testid="admin-blueprint-email-to" />
      <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Add a short note (optional)" className="max-w-xl text-sm" data-testid="admin-blueprint-email-note" />
      <button onClick={send} disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2 text-sm disabled:opacity-60" data-testid="admin-blueprint-email-send">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send blueprint
      </button>
    </div>
  );
}

export default function AdminBlueprint() {
  return (
    <div className="mb-10 rounded-2xl border border-primary/30 bg-primary/[0.05] p-5" data-testid="admin-coach-blueprint">
      <p className="font-serif text-xl flex items-center gap-2"><FileText className="w-5 h-5 text-primary" /> AI Coach blueprint for sister apps</p>
      <p className="text-sm text-muted-foreground mt-1">Everything another team needs to rebuild Adelaida in-house: prompts, memory, safety, voice, avatar, audio, costs.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        <a href={`${BASE}/api/admin/coach-blueprint`} target="_blank" rel="noreferrer" className="rounded-full bg-primary text-primary-foreground px-5 py-2 text-sm" data-testid="admin-blueprint-open">Open (print to PDF)</a>
        <a href={`${BASE}/api/admin/coach-blueprint?format=md`} className="rounded-full border border-border px-5 py-2 text-sm" data-testid="admin-blueprint-md">Download file</a>
        <a href="/brand/xcelio-coach-face-kit.zip" download className="rounded-full border border-border px-5 py-2 text-sm" data-testid="admin-face-kit">Face kit (photos)</a>
      </div>
      <AdminSisterApps />
      <EmailBlueprint />
    </div>
  );
}
